:host {
  display: block;
}

.field-container {
  display: grid;
  grid-template-columns: 10em 1fr 20px;
  align-items: center;
  gap: 1rem;
}

.custom-label {
  color: var(--theme-primary-color);
  text-align: right;
  align-items: center;
  font-weight: bold;
  gap: 0.5rem;
}

.custom-input,
.custom-input.active,
.custom-input.inactive {
  padding: 0.2rem;
  border-radius: 4px;
  font-size: 1rem;
  border: 1px solid var(--theme-secondary-color);
}

.custom-input.active {
  background-color: var(--theme-input-active-background);
}

.custom-input.inactive {
  background-color: var(--theme-input-inactive-background);
}

input:read-only {
  pointer-events: none;
}

.field-invalid {
  background-color: var(--theme-primary-color);
  -webkit-mask: var(--icon-reset);
  mask: var(--icon-reset);
  height: 1.0rem;
  width: 1.0rem;
  cursor: pointer;
  pointer-events: auto;
}

.field-valid {
  background-color: var(--theme-primary-color);
  -webkit-mask: var(--icon-valid);
  mask: var(--icon-valid);
  height: 1.0rem;
  width: 1.0rem;
  cursor: pointer;
  pointer-events: auto;
}
